import clsx from 'clsx';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import NotificationBar from '../components/notification-bar/NotificationBar';

import HeaderMobile from '../header-mobile/HeaderMobile';
import Header from '../header/Header';
import Sidebar from '../sidebar/Sidebar';

import scss from './Layout.module.scss';

function Layout({ children }) {
  const slimSidebar = useSelector((state) => state.sidebar.slim);

  return (
    <div className={scss.wrapper}>
      <Sidebar />

      <div className={clsx(scss.contentWrapper, slimSidebar && scss.slimSidebar)}>
        <Header />
        <HeaderMobile />

        <main className={scss.main}>{children}</main>
      </div>

      <NotificationBar />
    </div>
  );
}

export default Layout;
